import { SORT_DIRECTION } from '@avanta/shared/constants/common';
import { type SortingState } from '@tanstack/react-table';
import { type SortOrder } from 'types/common';

export const getServerSort = <T extends string>(
  sorting: SortingState,
  columnSortBy: Readonly<Record<string, T | undefined>>
): { sortBy?: T; sortOrder?: SortOrder } => {
  const [activeSort] = sorting;
  const sortBy = activeSort ? columnSortBy[activeSort.id] : undefined;

  if (!sortBy) {
    return {};
  }

  return {
    sortBy,
    sortOrder: activeSort.desc ? SORT_DIRECTION.desc : SORT_DIRECTION.asc,
  };
};
